import { TranslationKeys } from '../contexts/TranslationKeys';
import { Translator } from '../contexts/translator';
import { MultiSelectOption } from '../models/MultiSelectOption'

const getTagStatusOptions = (translate: Translator) : MultiSelectOption[] => {
    return [
    {
        value: '1',
        label: translate.byKey(TranslationKeys.normal)
    },
    {
        value: '2',
        label: translate.byKey(TranslationKeys.suspend)
    },
    {
        value: '3',
        label: translate.byKey(TranslationKeys.suspendWithAlarm)
    },
    {
        value: '4',
        label: translate.byKey(TranslationKeys.accessOverride)
    },
    {
        value: '5',
        label: translate.byKey(TranslationKeys.specialEvent1)
    },
    {
        value: '6',
        label: translate.byKey(TranslationKeys.specialEvent2)
    },
    // {
    //     value: '7',
    //     label: 'Scheduled Tour'
    // }, // Not supported yet. Leave here for later.
]};

export default getTagStatusOptions;
